$(document).ready(function () {

    // var currency;
    // var region;
    
    $('.dropdown--search__input').on("keyup",function(e) {

        if ( e.keyCode == 13 && $(".dropdown--search__input").val().length > 2 )
        {
            $(".header__search").trigger("submit");
        }
        
        if ( $(".dropdown--search__input").val().length < 1 )
        {
            $(".dropdown--search_result").css("display","none");
        }
        else
        {
            $.ajax({
                url: "/search",
                method: "POST",
                beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
                data: "searchterm="+$(".dropdown--search__input").val()+"&lang="+$(".header__search__lang").val()+"&currency="+currency,
                success: (result)=>{
                    $(".dropdown--search_result").css("display","block");
                    $(".dropdown--search_result").html(result);
                }
            });	
        }

    })


    $('.header__search').on("submit",function(e) {
        e.preventDefault();

        //alert($(".header_search").val().length);

        if ( $(".dropdown--search__input").val().length > 2 )
        {
            window.location.href = "/kereses/"+$(".dropdown--search__input").val();
        }

        return false;
    });

    /*$.ajax({
        url: "/users/getregionandcurrency",
        method: "POST",
        beforeSend: function(xhr){xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
        success: (result)=> {
            region = result.region;
            currency = result.currency;
        }
    });*/
})